import "../assets/styles/components/snack-bar.scss";

export default function SnackBar({ type, message, loading = false }) {
  return (
    <div
      className={`position-fixed p-3 w-100 d-flex align-items-center justify-content-center snack-bar snack-bar--${type}`}
    >
      {loading ? <div className="spinner"></div> : null}
      <strong className={loading ? "ms-3" : ""}>{message}</strong>
    </div>
  );
}
